import http from 'hub-http/clients/apiClient';
const API_BASE = '/navconfig/v2/home';
const OPTIONS = 'options';
const KEY = 'key';
export default class NavConfigAPI {
  static getHomePageOptions() {
    return http.get(`${API_BASE}/${OPTIONS}`);
  }
  static getDefaultHomePage() {
    return http.get(`${API_BASE}/${KEY}`);
  }
}